import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Spinner from 'builder/components/Spinner'
import Typography, { FontWeights } from 'builder/styles/typography'
import Icon24 from 'builder/components/Icon'

export const DocumentsContent = styled.div`
  padding: 32px 0 0 0;
`

export const DocumentsLineHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`

export const DocumentsLineTitle = styled.div`
  color: ${Colors.Neutral50};
  font-size: 16px;
  font-weight: 400;
  gap: 5px;
  display: flex;
  align-items: center;
`

export const DocumentsInfoContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 16px;
  justify-content: center;
`

export const DocumentsInfoSpinner = styled(Spinner)`
  width: 15px;
  height: 15px;
`

export const DocumentsInfoText = styled.div`
  color: ${Colors.Neutral90};

  ${Typography.Body}
  ${FontWeights.Regular}
`

export const DocumentsLineButton = styled.button`
  cursor: pointer;
  border: none;
`
export const DocumentsLineImg = styled.img`
  opacity: 0.6;
`
export const DocumentsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  & > :nth-child(even) > :first-child {
    /* margin-left: 24px; */
  }
`

export const AppliedDocIcon = styled(Icon24.Conversation)``
export const DocumentsListItem = styled.a`
  flex: 0 0 50%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  position: relative;

  &:hover {
    color: ${Colors.Blue50};
  }
`

export const DocumentThumbnail = styled.img`
  width: 48px;
  box-shadow: 0px 0px 2px 0px #0f387152;
  border-radius: 5px;
`

export const DocumentIconContainer = styled.div`
  position: absolute;
  height: 48px;
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const DocumentPlaceholderOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.25;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
`
export const ThumbnailPlaceholderContainer = styled.div`
  position: relative;
`
export const ThumbnailSpinner = styled(Spinner)``

export const DocumentDownload = styled.span`
  font-size: 16px;
  font-weight: 400;
  display: flex;
  align-items: center;
  max-width: 150px;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: 16px;
`

export const DocumentDownloadPlaceholder = styled.p`
  font-size: 16px;
  font-weight: 400;
  display: flex;
  align-items: center;
  max-width: 180px;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: 16px;
`

export const DocumentErrorLine = styled.div`
  margin: 16px;
  padding: 16px 24px;
  background: ${Colors.Neutral5};
  border-radius: var(--spacing-2XS);
  cursor: pointer;
  & > :nth-child(1) {
    color: ${Colors.Neutral90};
    ${Typography.Caption};
    ${FontWeights.Medium};
  }
  & > :nth-child(2) {
    color: ${Colors.Red50} !important;
    ${Typography.Caption};
    ${FontWeights.Regular};
  }
`
export const DropSection = styled.div`
  background: ${Colors.Blue10};
  color: ${Colors.Blue50};
  border: 1px dashed ${Colors.Blue50};
  height: 80px;
  width: 100%;
  ${Typography.Body};
  ${FontWeights.Medium};
  display: flex;
  align-items: center;
  justify-content: center;
  & > :first-child {
    margin-right: 6px;
  }
`
